import { ofbiz } from './http';

export function getMailTemplateList(query = {}, page = 1, pageSize = 20) {
  return ofbiz.postPage('notify/mailTemplateList', query, page, pageSize);
}

export function createMailTemplate(data) {
  return ofbiz.post('notify/mailTemplateCreate', data);
}

export function updateMailTemplate(data) {
  return ofbiz.post('notify/mailTemplateUpdate', data);
}

export function deleteMailTemplate(emailTemplateSettingId) {
  return ofbiz.post('notify/mailTemplateDelete', null, { emailTemplateSettingId });
}

export function getNotifyStaffList(query = {}, page = 1, pageSize = 500) {
  return ofbiz.postPage('notify/staffList', query, page, pageSize);
}

export function addNotifyStaff(partyId) {
  return ofbiz.post('notify/staffAdd', null, { partyId });
}

export function removeNotifyStaff(partyId) {
  return ofbiz.post('notify/staffRemove', null, { partyId });
}

export function testMail({ toAddress, subject, content, sendFrom }) {
  return ofbiz.post('notify/testMail', { toAddress, subject, content, sendFrom });
}

export function getMailHistory(query = {}, page = 1, pageSize = 20) {
  return ofbiz.postPage('notify/mailHistory', query, page, pageSize);
}
